import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

const input = "h-12 w-full rounded-2xl border border-white/10 bg-white/[0.04] px-4 text-sm text-zinc-100 outline-none transition-colors placeholder:text-zinc-500 focus:border-gold/60";

// Shared email/password form for the 3 admin accounts.
export const LoginForm = ({ onLogin, submitLabel, testId = "admin-login", className = "", children, footer }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${testId}-form`} className={className}>
      {children}
      <div className="mt-7 space-y-3">
        <input data-testid={`${testId}-email`} type="email" autoComplete="username" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} />
        <input data-testid={`${testId}-password`} type="password" autoComplete="current-password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
      </div>
      {error && <p data-testid={`${testId}-error`} className="mt-3 text-sm text-red-400">{error}</p>}
      <button data-testid={`${testId}-submit`} disabled={busy} className="mt-6 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-gold font-semibold text-ink transition-opacity hover:opacity-90 disabled:opacity-60">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} {submitLabel}
      </button>
      {footer}
    </form>
  );
};
